module.exports = __webpack_public_path__ + "static/home-bottom-47aa7e134aad997558ab897927f30ded.png";